import { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import UnderConstruction from './UnderConstruction';

const pageStyle = {
    minHeight: 'calc(100vh - 180px)',
    backgroundColor: '#15171b',
    color: '#ffffff',
    padding: '60px 20px',
};

const containerStyle = {
    maxWidth: '760px',
    margin: '0 auto',
};

const headingStyle = {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '12px',
};

const subheadingStyle = {
    fontSize: '18px',
    color: 'var(--highlight, #e9c548)',
    fontWeight: '600',
    marginBottom: '24px',
};

const bodyStyle = {
    fontSize: '15px',
    color: '#cccccc',
    lineHeight: '1.8',
    marginBottom: '20px',
};

const dividerStyle = {
    border: 'none',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    margin: '36px 0',
};

const cardRowStyle = {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '20px',
};

const cardStyle = {
    flex: '1',
    minWidth: '180px',
    backgroundColor: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '8px',
    padding: '20px',
};

const cardTitleStyle = {
    fontSize: '14px',
    fontWeight: '700',
    color: 'var(--highlight, #e9c548)',
    marginBottom: '8px',
};

const emailBlockStyle = {
    backgroundColor: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '8px',
    padding: '28px 32px',
    textAlign: 'center',
};

const emailLabelStyle = {
    fontSize: '13px',
    color: '#aaaaaa',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '10px',
};

const emailLinkStyle = {
    fontSize: '22px',
    fontWeight: '700',
    color: 'var(--highlight, #e9c548)',
    textDecoration: 'none',
    fontFamily: `var(--bodyfont) !important`
};

class Advertise extends Component {
    render() {
        const appName = window.app && window.app.appName;
        if (appName !== 'screenixx') {
            return <UnderConstruction {...this.props} />;
        }

        return (
            <div className="info-page">
                <Header />
                <div style={pageStyle}>
                    <div style={containerStyle}>
                        <h1 style={headingStyle}>Advertise With Us</h1>
                        <p style={subheadingStyle}>Reach a passionate, film-loving audience.</p>

                        <p style={bodyStyle}>
                            Screenixx connects your brand with a curated audience of movie enthusiasts, independent cinema supporters, and on-demand viewers who are actively engaged with the content they love.
                        </p>
                        <p style={bodyStyle}>
                            From pre-roll and mid-roll ad placements to branded content integrations and sponsorship opportunities, we offer flexible formats that fit your campaign goals.
                        </p>

                        <hr style={dividerStyle} />

                        <h2 style={{ ...headingStyle, fontSize: '22px', marginBottom: '20px' }}>Advertising Options</h2>
                        <div style={cardRowStyle}>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Pre-Roll Ads</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>High-visibility placements before featured content begins.</p>
                            </div>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Mid-Roll Ads</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>Contextual placements during content for maximum attention.</p>
                            </div>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Sponsored Content</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>Brand-aligned editorial and featured placement on the platform.</p>
                            </div>
                        </div>

                        <hr style={dividerStyle} />

                        <div style={emailBlockStyle}>
                            <p style={emailLabelStyle}>Get in touch with our advertising team</p>
                            <a href="mailto:Ads@screenixx.com" style={emailLinkStyle}>
                                Ads@screenixx.com
                            </a>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Advertise;
